import {Routes} from '@angular/router';

import {DashboardComponent} from './containers/dashboard/dashboard.component';

export const routes: Routes = [
	{path: '', component: DashboardComponent},
	{
		path: 'residents-tasks-status',
		// See https://github.com/angular/angular/issues/46697 and https://github.com/microsoft/TypeScript/issues/47682
		loadChildren: async () => (await import('@intocare/residents/tasks-status')).ResidentsTasksStatusModule
	}
];
